import type { FormData } from "../types";

interface CustomInstructionsSectionProps {
  formData: FormData;
  onFormChange: (field: keyof FormData, value: any) => void;
}

export function CustomInstructionsSection({
  formData,
  onFormChange,
}: CustomInstructionsSectionProps) {
  return (
    <div className="md:col-span-2">
      <label className="block text-sm font-semibold text-(--text-secondary) mb-2">
        Instruções Personalizadas (Opcional)
      </label>
      <textarea
        value={formData.customInstructions}
        onChange={(e) => onFormChange("customInstructions", e.target.value)}
        rows={3}
        className="w-full p-4 rounded-lg border border-(--border-color) bg-(--card-bg) text-(--text-primary) focus:ring-2 focus:ring-(--primary-color) focus:border-(--primary-color) outline-none resize-none text-sm transition-all"
        placeholder="Ex: Foco em aprendizagem baseada em projetos, usar exemplos do cotidiano..."
      />
    </div>
  );
}
